<form
  [formGroup]="form"
  class="flex flex-col space-y-4 w-full"
  *transloco="let fieldTranslation; read: 'field-types'"
>
  <mat-form-field class="fuse-mat-no-subscript w-full">
    <mat-label>{{ fieldTranslation("Placeholder") }}</mat-label>
    <input
      [placeholder]="fieldTranslation('Placeholder')"
      formControlName="placeholder"
      autocomplete="off"
      matInput
    />
  </mat-form-field>

  <div class="flex flex-row space-x-4">
    <mat-form-field class="fuse-mat-no-subscript w-full">
      <mat-label>Minimo</mat-label>
      <input
        type="number"
        formControlName="min"
        autocomplete="off"
        matInput
      />
    </mat-form-field>

    <mat-form-field class="fuse-mat-no-subscript w-full">
      <mat-label>Máximo</mat-label>
      <input
        type="number"
        formControlName="max"
        autocomplete="off"
        matInput
      />
    </mat-form-field>
  </div>
</form>
